import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IUser } from '../../types/user';

export interface IAuthReducer {
  isAuthenticated: boolean;
  isRememberMeEnabled: boolean;
  isLoading: boolean;
  user: IUser | null;
}

const initialState = {
  isLoading: true,
  isRememberMeEnabled: true,
  isAuthenticated: false,
  user: null,
} as unknown as IAuthReducer;

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setIsRememberMeEnabled: (state, action) => {
      state.isRememberMeEnabled = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
  },
});

export const {
  setIsAuthenticated,
  setIsRememberMeEnabled,
  setIsLoading,
  setUser,
  clearUser
} = authSlice.actions;
